import { h, Fragment } from 'preact'
import { FormattedNumber, UnifiedIntlOptions } from '../../../../lib/intl/FormattedNumber'
import { Message } from '../../../../lib/intl/Message'

type Props = {
  value?: number
  enhetId: string
  prefixId?: string
  options?: Intl.NumberFormatOptions & UnifiedIntlOptions
}

export function NummerMedEnhet({ value, prefixId, enhetId, options }: Props) {
  if (typeof value === 'undefined' || value === null) {
    return <Fragment>{' '}</Fragment>
  }

  return (
    <Fragment>
      <span aria-hidden="true">
        <FormattedNumber value={value} options={options} />
      </span>
      {/* eslint-disable-next-line jsx-a11y/aria-role */}
      <span class="nrk-sr" role="text">
        {prefixId && <Message id={prefixId} />}
        <FormattedNumber value={value} options={{ ...options, useGrouping: false }} />{' '}
        <Message id={enhetId} />
      </span>
    </Fragment>
  )
}
